import request from "../clientsApi";
import { API_ROUTES } from "../../config/baseURL";

export const userApi = {
  getRoles: async () => {
    const res = await request(API_ROUTES.rol, { method: "GET" });
    return res.json();
  },

  getUsers: async () => {
    const res = await request(API_ROUTES.getAllUsers, { method: "GET" });
    return res.json();
  },

  getUserById: async (id) => {
    const res = await request(API_ROUTES.getUserById(id), { method: "GET" });
    return res.json();
  },

  saveUser: async (userData) => {
    const isUpdate = !!userData.id; // Switch to PUT if editing existing user
    const res = await request(API_ROUTES.saveUser, {
      method: isUpdate ? "PUT" : "POST",
      body: JSON.stringify(userData),
    });
    return res.json();
  },
};

